query GetPledges(
  $page: Int
  $limit: Int
  $search: String
  $status: PledgeSearchEnum!
) {
  pledges(page: $page, limit: $limit, search: $search, status: $status) {
    collection {
      id
      firstName
      surname
      userId
      createdDate
      pledgorHomeCountry
      companyName
      currentPercentage
      dateSigned
      countersigned
      signed
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
